module.exports = __webpack_public_path__ + "img/D100_01.d5aacc30.png";